import _extends from "@babel/runtime/helpers/esm/extends";
import React, { forwardRef } from 'react';
import classNames from 'classnames/bind';
import { getMethodsForTestId } from "../../utils/getMethodsForTestId";
import styles from './RadioBase.css';
var cx = classNames.bind(styles);
export var RadioBase = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var checked = _ref.checked,
      className = _ref.className,
      disabled = _ref.disabled,
      id = _ref.id,
      name = _ref.name,
      onChange = _ref.onChange,
      readOnly = _ref.readOnly,
      required = _ref.required,
      tabIndex = _ref.tabIndex,
      theme = _ref.theme,
      value = _ref.value,
      namespace = _ref.namespace;

  var _getMethodsForTestId = getMethodsForTestId(namespace, 'radioBase'),
      getTestId = _getMethodsForTestId.getTestId;

  return /*#__PURE__*/React.createElement("span", _extends({
    className: cx('root', "theme_".concat(theme), className)
  }, getTestId()), /*#__PURE__*/React.createElement("input", _extends({
    id: id,
    ref: ref,
    name: name,
    disabled: disabled,
    onChange: onChange,
    checked: checked,
    readOnly: readOnly,
    required: required,
    tabIndex: tabIndex,
    value: value,
    className: cx('input'),
    type: "radio"
  }, getTestId('input'))), /*#__PURE__*/React.createElement("span", {
    className: cx('radio_box')
  }));
});
RadioBase.displayName = 'RadioBase';